// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!./github.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.codehilite tr td {
  border: 0;
  padding: 0;
  font-size: 13px;
  line-height: 1.428571429;
}

table.codehilite tr td.line-number {
  width: 1%;
}

table.codehilite tr td.line-number::before {
  content: attr(data-line-number);
  padding-right: 20px;
}

table.codehilite pre {
  background-color: transparent;
  border: 0;
  margin: 0;
  padding: 0;
  word-break: break-all;
  word-wrap: break-word;
}

table.codehilite.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  border-collapse: collapse;
  border-spacing: 0;
}

div.highlight:not(code .highlight) {
  overflow: scroll;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
